import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  Divider,
  FlexboxGrid,
  IconButton,
  Message,
  Panel,
  Stack,
  toaster,
  Tooltip,
  Uploader,
  Whisper
} from 'rsuite';
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import VisibleIcon from '@rsuite/icons/Visible';
import s1 from './templates/s1.jpg';
import Resizer from 'react-image-file-resizer';

import pdf_one from './pptout/pdf_one.jpg';
import pdf_two from './pptout/pdf_two.jpg';
import excel_one from './pptout/excel_one.jpg';
import excel_two from './pptout/excel_two.jpg';
import ppt_one from './pptout/ppt_one.jpg';
import ppt_two from './pptout/ppt_two.jpg';
import ppt_three from './pptout/ppt_three.jpg';
import ppt_four from './pptout/ppt_four.jpg';
import ppt_six from './pptout/ppt_six.png';
import ppt_seven from './pptout/ppt_seven.jpg';
import ppt_eight from './pptout/ppt_eight.jpg';
import ppt_nine from './pptout/ppt_nine.jpg';
import globalIP from '@/GlobelIP';

function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
}

const CataFormat3 = ({ activeKeyside, buyertype, buyerName }) => {
  ///// PPT Format Start /////
  const [mainid, setMainid] = useState();
  const [buyer, setBuyer] = useState('');
  const [fileInfo1, setFileInfo1] = useState({
    CSPath: null,
    LSPath: null
  });
  const [selectedSlides, setSelectedSlides] = useState([]);
  const [cdata, setCdata] = useState({
    CoverSlide: 'No',
    LastSlide: 'No',
    Type: '',
    BuyerName: '',
    Slides: []
  });
  useEffect(() => {
    setCdata(prevCdata => ({
      ...prevCdata,
      Type: buyertype,
      BuyerName: buyertype == 'Regular' ? 'N/A' : buyerName
    }));
    setBuyer(buyertype == 'Regular' ? '' : buyerName);
  }, [buyertype, buyerName]);
  const submit = async e => {
    e.preventDefault();
    if (cdata.Type == 'Buyer') {
      if (cdata.BuyerName == '' || cdata.BuyerName == null) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Buyer Name!!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata.CSPath) {
          formData.append('files.CSPath', cdata.CSPath);
        }
        if (cdata.LSPath) {
          formData.append('files.LSPath', cdata.LSPath);
        }
        const updatedCdata = {
          ...cdata,
          Slides: selectedSlides.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid) {
          url = `${globalIP}/api/temp-lib-emark-ppts/${mainid}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-emark-ppts`;
          method = 'POST';
        }

        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    } else {
      if (selectedSlides.length == 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Alteast one Body Slide !!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata.CSPath) {
          formData.append('files.CSPath', cdata.CSPath);
        }
        if (cdata.LSPath) {
          formData.append('files.LSPath', cdata.LSPath);
        }
        const updatedCdata = {
          ...cdata,
          Slides: selectedSlides.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid) {
          url = `${globalIP}/api/temp-lib-emark-ppts/${mainid}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-emark-ppts`;
          method = 'POST';
        }
        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            // Refresh page after 2 seconds (2000 milliseconds)
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    }
  };
  const resizeFile = (blobfile) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        blobfile,
        1500,
        1500,
        "JPEG",
        90,
        0,
        (uri) => {
          resolve(uri); // Resolving with the resized Base64 string
        },
        "blob", // Return as base64
        900,
        900
      );
    });
  const handleImageUpload = async (fileList, key) => {
    if (fileList.length > 0) {
      const lastIndex = fileList.length - 1;
      const file = fileList[lastIndex];
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const newfile = await resizeFile(file.blobFile)
      if (allowedExtensions.includes(fileExtension)) {
        setCdata({
          ...cdata,
          [key]: newfile
        });
        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
        previewFile(newfile, value => {
          setFileInfo1(prev => ({ ...prev, [key]: value }));
        });
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please Change Image should be jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [buyertype, buyerName]);
  const fetchData = async () => {
    try {
      let url;
      if (buyertype == 'Regular') {
        url = `${globalIP}/api/temp-lib-emark-ppts?populate=*&filters[Type][$eq]=${buyertype}`;
      } else {
        url = `${globalIP}/api/temp-lib-emark-ppts?populate=*&filters[Type][$eq]=${buyertype}&filters[BuyerName][$eq]=${buyerName}`;
      }
      const response = await fetch(url);
      const json = await response.json();
      setMainid(json.data[0]?.id);
      const fetchedSlides = json.data[0]?.attributes?.Slides || [];
      setFileInfo1(prev => ({
        ...prev,
        CSPath: `${globalIP}${json.data[0]?.attributes?.CSPath?.data?.attributes?.url ?? ''}`
      }));
      setFileInfo1(prev => ({
        ...prev,
        LSPath: `${globalIP}${json.data[0]?.attributes?.LSPath?.data?.attributes?.url ?? ''}`
      }));
      setCdata(prev => ({
        ...prev,
        CoverSlide: json.data[0]?.attributes?.CoverSlide ?? 'No',
        LastSlide: json.data[0]?.attributes?.LastSlide ?? 'No',
        Slides: fetchedSlides
      }));
      setSelectedSlides(fetchedSlides);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleCheckboxChange = (key, checked) => {
    setCdata({
      ...cdata,
      [key]: checked ? 'Yes' : 'No'
    });
  };
  const slides = [
    { TempName: 'Format F1', BuyerName: '', imgSrc: ppt_one },
    { TempName: 'Format F2', BuyerName: '', imgSrc: ppt_two },
    { TempName: 'Format F3', BuyerName: '', imgSrc: ppt_three },
    { TempName: 'Format F4', BuyerName: '', imgSrc: ppt_four },
    { TempName: 'Format F5', BuyerName: '', imgSrc: ppt_three },
    { TempName: 'Format F6', BuyerName: '', imgSrc: ppt_six },
    { TempName: 'Format Two F1', BuyerName: '', imgSrc: ppt_seven },
    { TempName: 'Format Three F1', BuyerName: '', imgSrc: ppt_eight },
    { TempName: 'Format Four F1', BuyerName: '', imgSrc: ppt_nine }
  ];
  const handleCheckboxChange1 = (slide, checked) => {
    if (checked) {
      setSelectedSlides(prev => [...prev, slide]);
    } else {
      setSelectedSlides(prev => prev.filter(s => s.TempName !== slide.TempName));
    }
  };
  ///// PPT Format End /////

  ///// PDF Format Start /////
  const [mainid1, setMainid1] = useState();
  const [buyer1, setBuyer1] = useState('');
  const [fileInfo11, setFileInfo11] = useState({
    CPPath: null,
    LPPath: null
  });
  const [selectedSlides1, setSelectedSlides1] = useState([]);
  const [cdata1, setCdata1] = useState({
    CoverPage: 'No',
    LastPage: 'No',
    Type: '',
    BuyerName: '',
    Pages: []
  });
  useEffect(() => {
    setCdata1(prevCdata => ({
      ...prevCdata,
      Type: buyertype,
      BuyerName: buyertype == 'Regular' ? 'N/A' : buyerName
    }));
    setBuyer1(buyertype == 'Regular' ? '' : buyerName);
  }, [buyertype, buyerName]);
  const submit1 = async e => {
    e.preventDefault();
    if (cdata1.Type == 'Buyer') {
      if (cdata1.BuyerName == '' || cdata1.BuyerName == null) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Buyer Name!!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata1.CPPath) {
          formData.append('files.CPPath', cdata1.CPPath);
        }
        if (cdata1.LPPath) {
          formData.append('files.LPPath', cdata1.LPPath);
        }
        const updatedCdata = {
          ...cdata1,
          Pages: selectedSlides1.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer1
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid1) {
          url = `${globalIP}/api/temp-lib-emark-pdfs/${mainid1}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-emark-pdfs`;
          method = 'POST';
        }

        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    } else {
      if (selectedSlides1.length == 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Alteast one Body Pages !!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata1.CPPath) {
          formData.append('files.CPPath', cdata1.CPPath);
        }
        if (cdata1.LPPath) {
          formData.append('files.LPPath', cdata1.LPPath);
        }
        const updatedCdata = {
          ...cdata1,
          Pages: selectedSlides1.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer1
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid1) {
          url = `${globalIP}/api/temp-lib-emark-pdfs/${mainid1}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-emark-pdfs`;
          method = 'POST';
        }
        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    }
  };
  const handleImageUpload1 = async (fileList, key) => {
    if (fileList.length > 0) {
      const lastIndex = fileList.length - 1;
      const file = fileList[lastIndex];
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const newfile = await resizeFile(file.blobFile)

      if (allowedExtensions.includes(fileExtension)) {
        setCdata1({
          ...cdata1,
          [key]: newfile
        });
        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
        previewFile(newfile, value => {
          setFileInfo11(prev => ({ ...prev, [key]: value }));
        });
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please Change Image should be jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  useEffect(() => {
    fetchData1();
  }, [buyertype, buyerName]);
  const fetchData1 = async () => {
    try {
      let url;
      if (buyertype == 'Regular') {
        url = `${globalIP}/api/temp-lib-emark-pdfs?populate=*&filters[Type][$eq]=${buyertype}`;
      } else {
        url = `${globalIP}/api/temp-lib-emark-pdfs?populate=*&filters[Type][$eq]=${buyertype}&filters[BuyerName][$eq]=${buyerName}`;
      }
      const response = await fetch(url);
      const json = await response.json();
      setMainid1(json.data[0]?.id);
      const fetchedSlides = json.data[0]?.attributes?.Pages || [];
      setFileInfo11(prev => ({
        ...prev,
        CPPath: `${globalIP}${json.data[0]?.attributes?.CPPath?.data?.attributes?.url ?? ''}`
      }));
      setFileInfo11(prev => ({
        ...prev,
        LPPath: `${globalIP}${json.data[0]?.attributes?.LPPath?.data?.attributes?.url ?? ''}`
      }));
      setCdata1(prev => ({
        ...prev,
        CoverPage: json.data[0]?.attributes?.CoverPage ?? 'No',
        LastPage: json.data[0]?.attributes?.LastPage ?? 'No',
        Pages: fetchedSlides
      }));
      setSelectedSlides1(fetchedSlides);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleCheckboxChange11 = (key, checked) => {
    setCdata1({
      ...cdata1,
      [key]: checked ? 'Yes' : 'No'
    });
  };
  const slides1 = [
    { TempName: 'Format F1', BuyerName: '', imgSrc: pdf_one },
    { TempName: 'Format F2', BuyerName: '', imgSrc: pdf_two }
  ];
  const handleCheckboxChange111 = (slide, checked) => {
    if (checked) {
      setSelectedSlides1(prev => [...prev, slide]);
    } else {
      setSelectedSlides1(prev => prev.filter(s => s.TempName !== slide.TempName));
    }
  };
  ///// PDF Format End /////

  ///// Excel Format Start /////
  const [mainid2, setMainid2] = useState();
  const [buyer2, setBuyer2] = useState('');
  const [fileInfo12, setFileInfo12] = useState({
    BannerPath: null
  });
  const [selectedSlides2, setSelectedSlides2] = useState([]);
  const [cdata2, setCdata2] = useState({
    Banner: 'No',
    Type: '',
    BuyerName: '',
    Body: []
  });
  useEffect(() => {
    setCdata2(prevCdata => ({
      ...prevCdata,
      Type: buyertype,
      BuyerName: buyertype == 'Regular' ? 'N/A' : buyerName
    }));
    setBuyer2(buyertype == 'Regular' ? '' : buyerName);
  }, [buyertype, buyerName]);
  const submit2 = async e => {
    e.preventDefault();
    if (cdata2.Type == 'Buyer') {
      if (cdata2.BuyerName == '' || cdata2.BuyerName == null) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Buyer Name!!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata2.BannerPath) {
          formData.append('files.BannerPath', cdata2.BannerPath);
        }
        const updatedCdata = {
          ...cdata2,
          Body: selectedSlides2.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer2
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid2) {
          url = `${globalIP}/api/temp-lib-emark-excels/${mainid2}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-emark-excels`;
          method = 'POST';
        }

        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    } else {
      if (selectedSlides2.length == 0) {
        toaster.push(
          <Message showIcon type="error">
            Please Select Alteast one Body !!!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const formData = new FormData();
        if (cdata2.BannerPath) {
          formData.append('files.BannerPath', cdata2.BannerPath);
        }

        const updatedCdata = {
          ...cdata2,
          Body: selectedSlides2.map(slide => ({
            TempName: slide.TempName,
            BuyerName: buyer2
          })) // Ensure proper structure
        };
        formData.append('data', JSON.stringify(updatedCdata));

        let url;
        let method;
        if (mainid2) {
          url = `${globalIP}/api/temp-lib-emark-excels/${mainid2}`;
          method = 'PUT';
        } else {
          url = `${globalIP}/api/temp-lib-emark-excels`;
          method = 'POST';
        }
        fetch(url, {
          method: method,
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            toaster.push(
              <Message showIcon type="success">
                Saved Successfully
              </Message>,
              { placement: 'topEnd' }
            );
          })
          .catch(error => {
            console.error(error);
            alert('Something went wrong. Please try again');
          });
      }
    }
  };
  const handleImageUpload2 = async (fileList, key) => {
    if (fileList.length > 0) {
      const lastIndex = fileList.length - 1;
      const file = fileList[lastIndex];
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const newfile = await resizeFile(file.blobFile)

      if (allowedExtensions.includes(fileExtension)) {
        setCdata2({
          ...cdata2,
          [key]: newfile
        });
        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
        previewFile(newfile, value => {
          setFileInfo12(prev => ({ ...prev, [key]: value }));
        });
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please Change Image should be jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  useEffect(() => {
    fetchData2();
  }, [buyertype, buyerName]);
  const fetchData2 = async () => {
    try {
      let url;
      if (buyertype == 'Regular') {
        url = `${globalIP}/api/temp-lib-emark-excels?populate=*&filters[Type][$eq]=${buyertype}`;
      } else {
        url = `${globalIP}/api/temp-lib-emark-excels?populate=*&filters[Type][$eq]=${buyertype}&filters[BuyerName][$eq]=${buyerName}`;
      }
      const response = await fetch(url);
      const json = await response.json();
      setMainid2(json.data[0]?.id);
      const fetchedSlides = json.data[0]?.attributes?.Body || [];
      setFileInfo12(prev => ({
        ...prev,
        BannerPath: `${globalIP}${json.data[0]?.attributes?.BannerPath?.data?.attributes?.url ?? ''
          }`
      }));
      setCdata2(prev => ({
        ...prev,
        Banner: json.data[0]?.attributes?.Banner ?? 'No',
        Body: fetchedSlides
      }));
      setSelectedSlides2(fetchedSlides);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleCheckboxChange12 = (key, checked) => {
    setCdata2({
      ...cdata2,
      [key]: checked ? 'Yes' : 'No'
    });
  };
  const slides2 = [
    { TempName: 'Format F1', BuyerName: '', imgSrc: excel_one },
    { TempName: 'Format F2', BuyerName: '', imgSrc: excel_two }
  ];
  const handleCheckboxChange112 = (slide, checked) => {
    if (checked) {
      setSelectedSlides2(prev => [...prev, slide]);
    } else {
      setSelectedSlides2(prev => prev.filter(s => s.TempName !== slide.TempName));
    }
  };
  ///// Excel Format End /////
  return (
    <Panel bordered>
      {activeKeyside === 'content1' && (
        <>
          <Stack justifyContent="flex-end">
            <Button appearance="primary" color="cyan" onClick={submit}>
              Save
            </Button>
          </Stack>
          <Stack>
            <b style={{ marginBottom: '5px' }}>Cover Slide</b>
            <Checkbox
              checked={cdata.CoverSlide === 'Yes'}
              onChange={(value, checked) => handleCheckboxChange('CoverSlide', checked)}
            />
          </Stack>
          <Panel bordered>
            <Stack direction="column">
              <Uploader
                onChange={e => handleImageUpload(e, 'CSPath')}
                fileListVisible={false}
                accept="image/jpeg,image/jpg"
                listType="picture"
                action={''}
              >
                <button style={{ width: 150, height: 150 }}>
                  {fileInfo1.CSPath ? (
                    <img src={fileInfo1.CSPath} width="100%" height="100%" />
                  ) : (
                    <CameraRetroIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Uploader>

              <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                <IconButton
                  icon={<VisibleIcon />}
                  size="sm"
                  active
                // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                />
              </Whisper>
            </Stack>
          </Panel>
          <Stack>
            <b>Body Slides</b>
            <p style={{ color: 'red' }}>*</p>
          </Stack>
          <Divider style={{ marginTop: '5px' }} />

          <FlexboxGrid style={{ textAlign: 'center', marginBottom: '20px' }}>
            {slides.map(slide => (
              <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '5px' }}>
                <Panel bordered>
                  <Stack direction="column">
                    <img src={slide.imgSrc} style={{ width: '50%', height: '50%' }} />
                    <Stack>
                      <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                        <IconButton
                          icon={<VisibleIcon />}
                          size="sm"
                          active
                        // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                        />
                      </Whisper>
                      <Checkbox
                        checked={selectedSlides.some(s => s.TempName === slide.TempName)}
                        onChange={(value, checked) => handleCheckboxChange1(slide, checked)}
                      >
                        {slide.TempName}
                      </Checkbox>
                    </Stack>
                  </Stack>
                </Panel>
              </FlexboxGrid.Item>
            ))}
          </FlexboxGrid>
          <Stack>
            <b style={{ marginBottom: '10px' }}>Last Slide</b>
            <Checkbox
              checked={cdata.LastSlide === 'Yes'}
              onChange={(value, checked) => handleCheckboxChange('LastSlide', checked)}
            />
          </Stack>
          <Divider style={{ marginTop: '5px' }} />

          <Panel bordered>
            <Stack direction="column">
              <Uploader
                onChange={e => handleImageUpload(e, 'LSPath')}
                fileListVisible={false}
                accept="image/jpeg,image/jpg"
                listType="picture"
                action={''}
              >
                <button style={{ width: 150, height: 150 }}>
                  {fileInfo1.LSPath ? (
                    <img src={fileInfo1.LSPath} width="100%" height="100%" />
                  ) : (
                    <CameraRetroIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Uploader>

              <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                <IconButton
                  icon={<VisibleIcon />}
                  size="sm"
                  active
                // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                />
              </Whisper>
            </Stack>
          </Panel>
        </>
      )}
      {activeKeyside === 'content2' && (
        <>
          <Stack justifyContent="flex-end">
            <Button appearance="primary" color="cyan" onClick={submit1}>
              Save
            </Button>
          </Stack>
          <Stack>
            <b style={{ marginBottom: '5px' }}>Cover Page</b>
            <Checkbox
              checked={cdata1.CoverPage === 'Yes'}
              onChange={(value, checked) => handleCheckboxChange11('CoverPage', checked)}
            />
          </Stack>
          <Panel bordered>
            <Stack direction="column">
              <Uploader
                onChange={e => handleImageUpload1(e, 'CPPath')}
                fileListVisible={false}
                accept="image/jpeg,image/jpg"
                listType="picture"
                action={''}
              >
                <button style={{ width: 150, height: 150 }}>
                  {fileInfo11.CPPath ? (
                    <img src={fileInfo11.CPPath} width="100%" height="100%" />
                  ) : (
                    <CameraRetroIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Uploader>

              <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                <IconButton
                  icon={<VisibleIcon />}
                  size="sm"
                  active
                // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                />
              </Whisper>
            </Stack>
          </Panel>
          <Stack>
            <b>Body sffsdfPages</b>
            <p style={{ color: 'red' }}>*</p>
          </Stack>
          <Divider style={{ marginTop: '5px' }} />

          <FlexboxGrid style={{ textAlign: 'center', marginBottom: '20px' }}>
            {slides1.map(slide => (
              <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '5px' }}>
                <Panel bordered>
                  <Stack direction="column">
                    <img src={slide.imgSrc} style={{ width: '50%', height: '50%' }} />
                    <Stack>
                      <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                        <IconButton
                          icon={<VisibleIcon />}
                          size="sm"
                          active
                        // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                        />
                      </Whisper>
                      <Checkbox
                        checked={selectedSlides1.some(s => s.TempName === slide.TempName)}
                        onChange={(value, checked) => handleCheckboxChange111(slide, checked)}
                      >
                        {slide.TempName}
                      </Checkbox>
                    </Stack>
                  </Stack>
                </Panel>
              </FlexboxGrid.Item>
            ))}
          </FlexboxGrid>
          <Stack>
            <b style={{ marginBottom: '10px' }}>Last Slide</b>
            <Checkbox
              checked={cdata1.LastPage === 'Yes'}
              onChange={(value, checked) => handleCheckboxChange11('LastPage', checked)}
            />
          </Stack>
          <Divider style={{ marginTop: '5px' }} />

          <Panel bordered>
            <Stack direction="column">
              <Uploader
                onChange={e => handleImageUpload1(e, 'LPPath')}
                fileListVisible={false}
                accept="image/jpeg,image/jpg"
                listType="picture"
                action={''}
              >
                <button style={{ width: 150, height: 150 }}>
                  {fileInfo11.LPPath ? (
                    <img src={fileInfo11.LPPath} width="100%" height="100%" />
                  ) : (
                    <CameraRetroIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Uploader>

              <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                <IconButton
                  icon={<VisibleIcon />}
                  size="sm"
                  active
                // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                />
              </Whisper>
            </Stack>
          </Panel>
        </>
      )}

      {activeKeyside === 'content3' && (
        <>
          <Stack justifyContent="flex-end">
            <Button appearance="primary" color="cyan" onClick={submit2}>
              Save
            </Button>
          </Stack>
          <Stack>
            <b style={{ marginBottom: '5px' }}>Banner</b>
            <Checkbox
              checked={cdata2.Banner === 'Yes'}
              onChange={(value, checked) => handleCheckboxChange12('Banner', checked)}
            />
          </Stack>
          <Panel bordered>
            <Stack direction="column">
              <p style={{ color: 'red' }}>Approx. dimension 1000 x 120 px</p>
              <Uploader
                onChange={e => handleImageUpload2(e, 'BannerPath')}
                fileListVisible={false}
                accept="image/jpeg,image/jpg"
                listType="picture"
                action={''}
              >
                <button style={{ width: 1000, height: 120 }}>
                  {fileInfo12.BannerPath ? (
                    <img src={fileInfo12.BannerPath} width="100%" height="100%" />
                  ) : (
                    <CameraRetroIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Uploader>

              <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                <IconButton
                  icon={<VisibleIcon />}
                  size="sm"
                  active
                // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                />
              </Whisper>
            </Stack>
          </Panel>
          <Stack>
            <b>Body</b>
            <p style={{ color: 'red' }}>*</p>
          </Stack>
          <Divider style={{ marginTop: '5px' }} />
          <FlexboxGrid style={{ textAlign: 'center', marginBottom: '20px' }}>
            {slides2.map(slide => (
              <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '5px' }}>
                <Panel bordered>
                  <Stack direction="column">
                    <img src={slide.imgSrc} style={{ width: '50%', height: '50%' }} />
                    <Stack>
                      <Whisper speaker={<Tooltip>View Sample</Tooltip>}>
                        <IconButton
                          icon={<VisibleIcon />}
                          size="sm"
                          active
                        // onClick={() => handleOpen(fileInfo1.PPT_coverpage)}
                        />
                      </Whisper>
                      <Checkbox
                        checked={selectedSlides2.some(s => s.TempName === slide.TempName)}
                        onChange={(value, checked) => handleCheckboxChange112(slide, checked)}
                      >
                        {slide.TempName}
                      </Checkbox>
                    </Stack>
                  </Stack>
                </Panel>
              </FlexboxGrid.Item>
            ))}
          </FlexboxGrid>
        </>
      )}
    </Panel>
  );
};

export default CataFormat3;
